import {useCallback, useState} from 'react';

import {downloadWorkforceProfileAnalysisPdf} from '../../../../lib/api/v1';

interface Args {
  companyId: string;
  profileId: string;
  fileName: string;
  onError?: (error: unknown) => void;
}

interface Response {
  downloadPdf: () => Promise<void>;
  isLoading: boolean;
}

export const useDownloadWorkforceProfileAnalysisPdf = ({companyId, profileId, fileName, onError}: Args): Response => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadPdf = useCallback(async () => {
    setIsLoading(true);
    try {
      const blob = await downloadWorkforceProfileAnalysisPdf(companyId, profileId);
      const pdfBlob = new Blob([blob], {type: 'application/pdf'});

      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error fetching workforce profile analysis PDF:', err);
      onError?.(err);
    } finally {
      setIsLoading(false);
    }
  }, [companyId, profileId, fileName, onError]);

  return {downloadPdf, isLoading};
};
